import { render, staticRenderFns } from "./ClusterAdministration.vue?vue&type=template&id=a3169d72&scoped=true"
import script from "./ClusterAdministration.vue?vue&type=script&lang=js"
export * from "./ClusterAdministration.vue?vue&type=script&lang=js"
import style0 from "./ClusterAdministration.vue?vue&type=style&index=0&id=a3169d72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3169d72",
  null
  
)

export default component.exports